import { gql } from 'graphql-request';
import { graphQLApi } from 'utils/Api';
import {
  BulkDeclareValueInput,
  MutationBulkDeleteFlexibleBenefitsResponse,
  BulkDeclareValueInputVariables,
} from '../types';

const bulkDeclareComponentsValuesMutation = gql`
  mutation BulkDeclareValue($input: BulkDeclareValueInput!) {
    payrollBulkDeclareAssignmentValues(input: $input) {
      data {
        assignmentId
      }
      code
      success
      message
    }
  }
`;

export const declareBulkComponentsValues = (input: BulkDeclareValueInputVariables) => {
  return graphQLApi<MutationBulkDeleteFlexibleBenefitsResponse, BulkDeclareValueInput>({
    query: bulkDeclareComponentsValuesMutation,
    queryVariables: { input },
  });
};
